import { CourseTile } from "./CourseTile";

export function CourseGrid({ cats, countFor, onOpen, testId, favIds, onFav, lockedIds }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid={testId}>
      {cats.map((c, i) => (
        <CourseTile key={c.id} c={c} i={i} count={countFor(c.id)} onOpen={onOpen}
          favorited={favIds?.has(c.id)} onFav={onFav} locked={lockedIds?.has(c.id)} />
      ))}
    </div>
  );
}
